import { ErrorHandlingModal } from 'components/ErrorHandlingModal';
import { ModalDialog } from 'components/ModalDialog';
import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { setContractSeasonsGql } from 'pages/Project/UerProject/Contract/ContractQueries';
import { Card, DateTime } from 'uikit';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import * as R from 'ramda';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

interface ISeasonsSelectModal {
    onClose: () => void;
    onSuccess: () => void;
    contractId: number;
    minDate?: Date;
    maxDate?: Date;
}

export const SeasonsSelectModal: React.FC<ISeasonsSelectModal> = (props) => {
    const dispatch = useDispatch();
    const { onClose, onSuccess, contractId, minDate, maxDate } = props;
    const [seasonsRange, setSeasonsRange] = useState<[Date?, Date?]>([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleChangeSeasons = useCallback(({ value }) => setSeasonsRange(value), []);

    const [
        setContractSeasonsData,
        setContractSeasonsStatus,
        setContractSeasonsErr,
        setContractSeasonsRequest,
        setContractSeasonsDataUpdate,
    ] = useRequest({
        requestId: 'setContractSeasons',
        query: setContractSeasonsGql,
        withEffect: false,
    });

    const onConfirm = useCallback(() => {
        const yearsRange = seasonsRange.map((date) => date?.getFullYear()).filter(R.is(Number));

        setIsSubmitted(true);
        dispatch(
            setContractSeasonsRequest({
                contractId,
                years: R.range(yearsRange[0], yearsRange[1] + 1),
            }),
        );
    }, [contractId, dispatch, seasonsRange, setContractSeasonsRequest]);

    const onCloseModalError = useCallback(() => {
        setIsSubmitted(false);
    }, []);

    const onCreateReport = useCallback(() => {
        ExportCSVReport(setContractSeasonsData?.uerSetContractSeasons?.validation);
    }, [setContractSeasonsData?.uerSetContractSeasons?.validation]);

    useEffect(() => {
        if (
            setContractSeasonsData?.uerSetContractSeasons?.result &&
            setContractSeasonsStatus === RequestStatus.SUCCESS
        ) {
            dispatch(setContractSeasonsDataUpdate(undefined));
            setTimeout(() => onSuccess(), 100);
        }
    }, [
        dispatch,
        onSuccess,
        setContractSeasonsData?.uerSetContractSeasons?.result,
        setContractSeasonsDataUpdate,
        setContractSeasonsStatus,
    ]);

    useEffect(() => () => dispatch(setContractSeasonsDataUpdate(undefined)), [dispatch, setContractSeasonsDataUpdate]);

    return (
        <ModalDialog
            title="Выбор сезонов"
            isOpen
            onClose={onClose}
            onConfirm={onConfirm}
            btnConfirmLabel="Выбрать"
            btnConfirmDisabled={!(seasonsRange[0] && seasonsRange[1])}
            style={{ width: 340 }}
        >
            <div style={{ background: 'var(--color-bg-stripe)', display: 'flex', padding: '24px 0' }}>
                <Card
                    shadow={false}
                    border
                    verticalSpace="xs"
                    horizontalSpace="xs"
                    style={{ background: 'white', margin: '0 auto' }}
                >
                    <DateTime
                        type="year"
                        value={seasonsRange}
                        onChangeRange={handleChangeSeasons}
                        minDate={minDate}
                        maxDate={maxDate}
                    />
                </Card>
                <ErrorHandlingModal
                    titleText="Редактирование прочих затрат"
                    isSubmitted={isSubmitted}
                    statusRequest={setContractSeasonsStatus}
                    dataRequest={setContractSeasonsData?.uerSetContractSeasons}
                    errorsRequest={setContractSeasonsErr}
                    handleCloseModalError={onCloseModalError}
                    handleCreateReport={onCreateReport}
                />
            </div>
        </ModalDialog>
    );
};

SeasonsSelectModal.displayName = 'SeasonsSelectModal';
